import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const DataRangeSelect = (props) => {
  const {
    onChange,
  } = props;

  return (
    <div
      style={{
        fontWeight: 400,
        fontSize: 14,
        display: 'flex',
        gap: 6,
        alignItems: 'center',
      }}
    >
      <label
        style={{
          color: '#A7B7C0',
        }}
      >
        Show data from:
      </label>
      <Select
        defaultValue="1"
        id="range"
        onChange={onChange}
        getPopupContainer={() => document.body} // keeps dropdown from showing up behind graphs or modals
        style={{
          width: 150,
        }}
        options={[
          {
            value: '1',
            label: 'Last 24 hours',
          },
          {
            value: '7',
            label: 'Last 7 days',
          },
          {
            value: '30',
            label: 'Last 30 days',
          },
        ]}
      />
    </div>
  );
};

DataRangeSelect.propTypes = {
  onChange: PropTypes.func,
};

DataRangeSelect.defaultProps = {
  onChange: () => {},
};

export default DataRangeSelect;
